module.exports = __webpack_public_path__ + "img/project14_2.jpg.3ab0c20c.webp";